import { useState } from 'react';
import { Spinner } from "@blueprintjs/core";
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import VideoBlock from '../../Blocks/VideoBlock';
import QuizBlock from '../Quiz/QuizBlock';

import { useSelector } from 'react-redux'
import { authSelector } from '../../store';
import { authProvider } from '../../auth';

const _ = require('lodash');


function LessonPartContent({ course, lesson, lesson_part, opUpdateLessonPart }) {
  const auth = useSelector(authSelector);
  const history = useHistory();
  const [answers, setAnswers] = useState({});
  const [wrongAnswers, setWrongAnswers] = useState([]);
  const [correctAnswers, setCorrectAnswers] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [navigating, setNavigating] = useState(false);
  const { t } = useTranslation();

  const onView = () => {
    authProvider.request(auth, "post", `/api/courses/${course.slug}/lessons/${lesson.id}/lesson_parts/${lesson_part.id}/complete/`).then(() => {
      if (opUpdateLessonPart) {
        opUpdateLessonPart(lesson_part.id);
      }
    }).catch(() => {});
  };

  const navigateTo = (res) => {
    if (res.data) {
      const lp = res.data;
      history.push(`/course/${course.slug}/${lp.lesson_id}/${lp.id}/`);
    } else {
      history.push(`/course/${course.slug}/`);
    }
  };

  const handleNext = (event) => {
    event.preventDefault();
    setNavigating(true);
    authProvider.request(auth, "post", `/api/courses/${course.slug}/lessons/${lesson.id}/lesson_parts/${lesson_part.id}/next/`)
      .then((resNext) => {
        if (auth) {
          authProvider.request(auth, "post", `/api/courses/${course.slug}/lessons/${lesson.id}/lesson_parts/${lesson_part.id}/complete/`)
            .then(() => navigateTo(resNext))
            .catch(() => navigateTo(resNext));
        } else {
          navigateTo(resNext);
        }
      })
      .catch(() => setNavigating(false));
  };

  const handlePrevious = (event) => {
    event.preventDefault();
    setNavigating(true);
    authProvider.request(auth, "post", `/api/courses/${course.slug}/lessons/${lesson.id}/lesson_parts/${lesson_part.id}/previous/`)
      .then(navigateTo)
      .catch(() => setNavigating(false));
  };

  const handleCheck = (event) => {
    event.preventDefault();
    authProvider.request(auth, "post", `/api/courses/${course.slug}/lessons/${lesson.id}/lesson_parts/${lesson_part.id}/check/`, answers).then((res) => {
      if (res.data.is_passed) {
        if (res.data.next_lesson_part) {
          const lesson_part = res.data.next_lesson_part;
          history.push(`/course/${course.slug}/${lesson_part.lesson_id}/${lesson_part.id}/`);
        } else {
          history.push(`/course/${course.slug}/`);
        }
      } else {
        setWrongAnswers(res.data.wrong_answers);
        setCorrectAnswers(res.data.correct_answers);
        setErrorMessage(t("lesson_part_view.try_fail"));
        setAnswers({});
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
    }).catch(() => {});
  };

  const handleChangeAnswer = (quiz_item_id, answer) => {
    let new_answers = _.cloneDeep(answers);
    new_answers[quiz_item_id] = {
      "answer": answer
    };
    setAnswers(new_answers);
  };

  if (lesson_part.category === "VIDEO") {
    return (
      <div>
        <div className="video-responsive">
          <VideoBlock onView={onView} video={lesson_part.videos[0]}/>
        </div>

        <div className="lesson-nav-row">
          <button onClick={handlePrevious} disabled={navigating} type="button" className="btn btn-default lesson-nav-btn">
            {navigating && <Spinner size={16} />}
            {t("buttons.previous")}
          </button>
          <button onClick={handleNext} disabled={navigating} type="button" className="btn btn-primary bg-soft-success lesson-nav-btn">
            {navigating && <Spinner size={16} />}
            {t("buttons.next")}
          </button>
        </div>

        <div>
          <p dangerouslySetInnerHTML={{ __html: lesson_part.description }}></p>
        </div>
      </div>
    )
  }

  if (lesson_part.category === "QUIZ") {
    return (
      <div className="quiz-page">
        {errorMessage && (
          <div className="quiz-error-banner">
            <i className="icon-feather-x-circle"></i>
            {errorMessage}
          </div>
        )}

        <QuizBlock onChangeAnswer={handleChangeAnswer} answers={answers} quiz={lesson_part.quizzes[0]} wrongAnswers={wrongAnswers} correctAnswers={correctAnswers} />

        <div className="quiz-submit-row">
          {auth
            ? <button onClick={handleCheck} type="button" className="quiz-submit-btn">{t("buttons.check")}</button>
            : <a className="quiz-submit-btn" href="/login">{t("login.title")}</a>
          }
        </div>
      </div>
    )
  }
}

export default LessonPartContent;
